var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: { data: _vm.conciergeEnquiries },
          on: { "expand-change": _vm.onExpandChange }
        },
        [
          _c("el-table-column", {
            attrs: { type: "expand" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          padding: "10px",
                          "background-color": "#f3eeee"
                        }
                      },
                      [
                        _c(
                          "el-row",
                          { attrs: { gutter: 10, type: "flex" } },
                          [
                            _c("el-col", { attrs: { span: 8 } }, [
                              _c(
                                "div",
                                { staticClass: "info-item" },
                                [
                                  _c("div", { staticClass: "info-label" }, [
                                    _c("i", {
                                      staticClass: "el-icon-notebook-2"
                                    }),
                                    _vm._v(" Agent Notes\n                  ")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "el-form",
                                    {
                                      staticStyle: {
                                        "font-family": "DINosaur-a, sans-serif"
                                      },
                                      attrs: {
                                        "label-position": "top",
                                        "label-width": "100px"
                                      },
                                      nativeOn: {
                                        submit: function($event) {
                                          $event.preventDefault()
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "el-row",
                                        { attrs: { gutter: 10 } },
                                        [
                                          _c(
                                            "el-col",
                                            { attrs: { span: 24 } },
                                            [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: { label: "Agent Note" }
                                                },
                                                [
                                                  _c("el-input", {
                                                    attrs: {
                                                      type: "textarea",
                                                      rows: "3",
                                                      placeholder:
                                                        "Agent notes",
                                                      maxlength: "100",
                                                      "show-word-limit": ""
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.agentNotes[
                                                          scope.row.contactId
                                                        ],
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.agentNotes,
                                                          scope.row.contactId,
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "agentNotes[scope.row.contactId]"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-col",
                                            { attrs: { span: 24 } },
                                            [
                                              _c(
                                                "el-button",
                                                {
                                                  staticClass: "add-note-btn",
                                                  attrs: {
                                                    icon: "el-icon-plus"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.addNote(
                                                        scope.row.contactId
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v("Add Note")]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ]),
                            _vm._v(" "),
                            _c("el-col", { attrs: { span: 16 } }, [
                              _c("div", { staticClass: "info-item" }, [
                                _c("div", { staticClass: "info-label" }, [
                                  _vm._v("Agent Note History")
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "info-content",
                                    staticStyle: {
                                      display: "block",
                                      width: "100%"
                                    }
                                  },
                                  [
                                    Array.isArray(
                                      _vm.registerBuyerNotesHistory[
                                        scope.row.contactId
                                      ]
                                    ) &&
                                    _vm.registerBuyerNotesHistory[
                                      scope.row.contactId
                                    ].length > 0
                                      ? _c(
                                          "el-table",
                                          {
                                            staticClass: "compact-table",
                                            staticStyle: { width: "100%" },
                                            attrs: {
                                              data:
                                                _vm.registerBuyerNotesHistory[
                                                  scope.row.contactId
                                                ],
                                              height: "200",
                                              "row-style": _vm.rowStyle
                                            }
                                          },
                                          [
                                            _c("el-table-column", {
                                              attrs: {
                                                prop: "created",
                                                label: "Date",
                                                width: "180"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("el-table-column", {
                                              attrs: {
                                                label: "Channel Partner",
                                                width: "180"
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function(innerScope) {
                                                      return [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              innerScope.row
                                                                .cpFirstName +
                                                                " " +
                                                                innerScope.row
                                                                  .cpLastName
                                                            )
                                                          )
                                                        ])
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                true
                                              )
                                            }),
                                            _vm._v(" "),
                                            _c("el-table-column", {
                                              attrs: {
                                                prop: "note",
                                                label: "Note"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      : _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              padding: "10px",
                                              "text-align": "center"
                                            }
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "empty-text" },
                                              [_vm._v("No notes available")]
                                            )
                                          ]
                                        )
                                  ],
                                  1
                                )
                              ])
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "firstName", "min-width": "150", label: "Name" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("span", [_vm._v(_vm._s(_vm.getFullName(scope.row)))])
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "email", "min-width": "200", label: "Email" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "phoneNumber",
              "min-width": "250",
              label: "Phone Number"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "propertyAddress",
              "min-width": "150",
              label: "Property Address"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-tooltip",
                      {
                        staticClass: "item",
                        attrs: {
                          effect: "dark",
                          content: scope.row.propertyAddress,
                          placement: "right"
                        }
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.truncateQuestion(scope.row.propertyAddress)
                            )
                          )
                        ])
                      ]
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "nominatedClientName",
              "min-width": "150",
              label: "Nominated Client Name"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "question", "min-width": "200", label: "Question" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-tooltip",
                      {
                        staticClass: "item",
                        attrs: {
                          effect: "dark",
                          content: scope.row.question,
                          placement: "right"
                        }
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.truncateQuestion(scope.row.question))
                          )
                        ])
                      ]
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "created", "min-width": "200", label: "Date" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.created))])]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "propertyId", "min-width": "200", label: "Actions" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        staticClass: "btn-link",
                        attrs: { type: "text", icon: "el-icon-view" },
                        on: {
                          click: function($event) {
                            return _vm.showPropertyDetail(1, scope.row)
                          }
                        }
                      },
                      [_vm._v("View\n            Property\n          ")]
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.totalConciergeEnquiries
        ? _c(
            "div",
            { staticClass: "fen" },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.pageConciergeEnquiries,
                  "page-size": 25,
                  layout: "total, prev, pager, next",
                  total: _vm.totalConciergeEnquiries
                },
                on: { "current-change": _vm.handleCurrentChange }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-43460f27", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43460f27","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/enquiry/enquiryTable.vue
// module id = null
// module chunks = 